import { request } from '@/utils/http'

// ===================== 类型定义 =====================

/**
 * 按业务ID标记已读请求
 */
export interface BatchMarkAsReadRequest {
  /** 业务类型：1-询价、2-报价、3-订单 */
  businessType: number
  /** 业务数据ID */
  businessId: string
}

/**
 * 统计未读数量响应
 */
export interface CountUnreadVO {
  /** 业务类型：1-询价、2-报价、3-订单 */
  businessType: number
  /** 该业务类型的总未读数量 */
  totalUnreadCount: number
  /** 该业务类型下各业务ID的未读数量，key为业务ID，value为未读数量 */
  businessIdUnreadMap: Record<string, number>
}

// ===================== 接口实现 =====================

/**
 * 按业务ID标记已读
 */
const reminderSilentConfig = { showErrorMessage: false as const }

export const markAsReadByBusinessId = (data: BatchMarkAsReadRequest) => {
  return request.post<null>(
    '/universal/business/reminder/read/byBusinessId',
    data,
    reminderSilentConfig
  )
}

/**
 * 统计未读数量（universal-service 未部署时 404，不弹全局错误）
 */
export const countUnread = () => {
  return request.post<CountUnreadVO[]>(
    '/universal/business/reminder/unread/count',
    {},
    reminderSilentConfig
  )
}
